/* src/app/shared/message-modal/message-modal.component.scss */
:host ::ng-deep .modal-body a {
  color: #0d6efd;
}
:host ::ng-deep .modal-body a:hover,
:host ::ng-deep .modal-body a:focus {
  color: #0a58ca;
}
/*# sourceMappingURL=message-modal.component.css.map */
